import _typeof from "@babel/runtime/helpers/typeof";
var focusable = [['BUTTON'], ['SELECT'], ['TEXTAREA'], ['INPUT'], ['A', {
  has: 'href'
}], ['AREA', {
  has: 'href'
}], ['SUMMARY'], ['IFRAME'], ['OBJECT'], ['EMBED'], ['AUDIO', {
  has: 'controls'
}], ['VIDEO', {
  has: 'controls'
}], [{
  has: 'tabindex'
}], [{
  has: 'contenteditable'
}], [{
  has: 'autofocus'
}]];
export var isFocusable = function isFocusable(node) {
  var _node$ownerDocument$d;
  if (!node) return false;
  if (!node.ownerDocument) return false;
  if (!((_node$ownerDocument$d = node.ownerDocument.defaultView) !== null && _node$ownerDocument$d !== void 0 && _node$ownerDocument$d.HTMLElement)) return false;
  if (!(node instanceof node.ownerDocument.defaultView.HTMLElement || node instanceof node.ownerDocument.defaultView.SVGElement)) return false;
  if (node.hasAttribute('disabled')) return false;
  if (node.getAttribute('tabindex') === '-1') return false;
  var tagName = node.tagName;
  for (var _i = 0, _focusable = focusable; _i < _focusable.length; _i++) {
    var params = _focusable[_i];
    if (params.every(function (param) {
      if (typeof param === 'string' && param === tagName) return true;
      if (_typeof(param) === 'object' && param.has && node.hasAttribute(param.has)) return true;
      return false;
    })) return true;
  }
  return false;
};
//# sourceMappingURL=isFocusable.mjs.map